// extracted by mini-css-extract-plugin
module.exports =  {"root":"oM7MAsR0J4po0pH1prGq"};